<template>
  <v-app v-resize="onResize">
    <app-header></app-header>

    <v-content>
      <div class="app">
        <router-view></router-view>
      </div>
    </v-content>


    <app-footer></app-footer>


    <app-loader></app-loader>
    <vue-snotify></vue-snotify>

    <popup-login></popup-login>
    <popup-user-access-denied></popup-user-access-denied>

  </v-app>
</template>

<style lang="sass" rel="stylesheet/sass" src="./assets/sass/main.sass"></style>

<script>
  import { mapMutations } from 'vuex'

  import appHeader from '@/components/header/index.vue'
  import appFooter from '@/components/footer/index.vue'
  import appLoader from '@/components/loader/index.vue'
  import popupLogin from "@/components/popups/popup-login/index.vue";
  import popupUserAccessDenied from "@/components/popups/popup-user-access-denied/index.vue";

  import {LA_INIT} from '@/utils/listHubAPI'

  export default {
    name: 'app',
    //---components
    components: {
      popupLogin,
      popupUserAccessDenied,
      appHeader,
      appFooter,
      appLoader,
    },
    //---data
    data () {
      return {}
    },
    //---hooks
    created: function () {
      LA_INIT();
    },
    mounted(){

      window.addEventListener('scroll', this.lazyLoad);
      window.scrollTo(0, 0);
      if(!this.goToPositionScroll && this.positionScroll !== 0){
        setTimeout(() => {
          window.scrollTo(0, this.positionScroll);
        }, 10)
      }
      this.onResize();
    },
    //---methods
    methods: {
      ...mapMutations({
        setAppSize: 'APP/APP_SIZE_SET'
      }),
      onResize() {
        this.setAppSize();
      },
    }
  }
</script>